"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var UserMessageConverter_1 = require("../../user-messages/conversions/UserMessageConverter");

var ReleaseItemRepricing_1 = require("../model/ReleaseItemRepricing");

var ReleaseItemRepricingConverter_1 = require("./ReleaseItemRepricingConverter");

var ReleaseItemRepricingConverterImpl =
/*#__PURE__*/
function (_ReleaseItemRepricing) {
  _inherits(ReleaseItemRepricingConverterImpl, _ReleaseItemRepricing);

  function ReleaseItemRepricingConverterImpl(userMsgsConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, ReleaseItemRepricingConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemRepricingConverterImpl).call(this));
    _this.userMsgsConverter = userMsgsConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseItemRepricingConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReleaseItemRepricing_1.ReleaseItemRepricing(ReleaseItemRepricing_1.ReleaseItemRepricing.schema.possible.valueOfField(source), conversions.asObjectOpt(source, 'possibleFrom', function (v) {
        return conversions.toDate(v);
      }), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        possible: source.possible,
        possibleFrom: source.possibleFrom != null ? conversions.fromDate(source.possibleFrom) : null,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      return document;
    }
  }]);

  return ReleaseItemRepricingConverterImpl;
}(ReleaseItemRepricingConverter_1.ReleaseItemRepricingConverter);

ReleaseItemRepricingConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserMessageConverter_1.UserMessageConverter, ValidationResultConverter_1.ValidationResultConverter])], ReleaseItemRepricingConverterImpl);
exports.ReleaseItemRepricingConverterImpl = ReleaseItemRepricingConverterImpl;